import {CONTENT_TYPE_TEXT, CONTENT_CATEGORY_PROJECT} from '../../constants';

export default {
  id: 'DELETE_FROM_OPER',
  title: 'Wie kann ich eine Organisation aus einem Projekt löschen?',
  description: '',
  categories: [CONTENT_CATEGORY_PROJECT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Um eine Organisation aus einem Projekt zu löschen, können Sie Ihre Anfrage an den Kundendienst richten. Geben Sie dabei den Namen des Projekts, den Namen der Organisation und die Organisationsnummer der zu löschenden Organisation an.'
  }]
};
